export default class InvalidModuleScoreError extends Error {
  moduleScore: number | null | undefined;

  constructor(score: number | null | undefined) {
    super(
      `Encountered an invalid score for a completed session module: "${String(
        score
      )}"`
    );
    this.moduleScore = score;
  }
}
